import Pochta from "./Pochta";
function ESTJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
             <div className="image-wrapper">
       <img src="/img/ESTJ Менеджер.png" className="bigESTJ"/>
       </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ESTJ</h2>
  <p><strong>Процент населения:</strong> 8–10%</p>
<p><strong>Среди мужчин:</strong> 10–12%</p>
<p><strong>Среди женщин:</strong> 6–8%</p>
<p><strong>Стратегия:</strong> Организация и управление</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ESTJ черпают энергию из общения и управления процессами. 
  Им нужно быть в центре событий, организовывать и контролировать. 
  Они восстанавливают силы, видя порядок и результат своей работы.
</p>
<p>
  Решения ESTJ принимают на основе логики и фактов. 
  Они доверяют проверенным методам и не любят неопределённость. 
  Они ценят порядок, дисциплину и эффективность.
</p>
<p>
  Это прирождённые руководители и организаторы. 
  Они всегда знают, как навести порядок. 
  Им трудно принимать необязательность, но их работа приносит реальные результаты.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ESTJ — это диктатор в хорошем смысле. Они любят указывать, контролировать и наводить порядок. 
  Их прямолинейность иногда ранит, и они могут не замечать, что обидели человека. 
  Им сложно отступать от правил, и они не терпят хаоса — даже творческого.
</p>

<p>
  ESTJ — это человек, который может организовать хаос так, что никто не заметит, что он был. 
  Они — машина по наведению порядка. Их можно не любить за жёсткость, но их результаты говорят сами за себя. 
  Если вам нужен порядок — позовите ESTJ. Только будьте готовы, что они укажут вам на ваши ошибки.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ESTJ;